module.exports = __webpack_public_path__ + "img/copa_bronce.60cd8d5e.png";